import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-teacher-list",
  "use": "icon-teacher-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-teacher-list\"><path d=\"M876 98H201.4c-28.7 0-51.9 23.2-51.9 51.9v155.7h-25.9c-14.4 0-25.9 11.6-25.9 25.9 0 14.4 11.6 25.9 25.9 25.9h25.9v129.7h-25.9c-14.4 0-25.9 11.6-25.9 25.9 0 14.4 11.6 25.9 25.9 25.9h25.9v129.7h-25.9c-14.4 0-25.9 11.6-25.9 25.9s11.6 25.9 25.9 25.9h25.9v155.7c0 28.7 23.2 51.9 51.9 51.9H876c28.7 0 51.9-23.2 51.9-51.9V149.9c0-28.8-23.2-51.9-51.9-51.9zM444.5 392.1c2.8-4 4-5.2 10-5.2 0-57.1 32.7-107.4 101-107.4 67.9 0 100.6 50.3 100.6 107.4 6 0 7.2 1.2 10 5.2s1.2 38.3-16 49.5c-4.4 2-9.2 1.6-10 1.6-4.8 8.8-16.8 82.6-84.6 82.6-67.9 0-80.2-73.4-85-82.6-0.8 0.4-5.6 0.8-10-1.2-17.2-11.5-18.8-45.9-16-49.9zM765.4 727c0 4-3.2 19.6-21.2 19.6H366.6c-18 0-21.2-15.6-21.2-19.6v-97s2-23.5 12.8-34.3c8-11.2 47.5-33.1 112.6-52.7l84.6 138.9L640.1 543c65.5 19.6 104.6 41.5 112.6 52.7 10.8 11.2 12.8 34.3 12.8 34.3v97z m0 0\" p-id=\"15628\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/teacher-list.svg
// module id = 6lGa
// module chunks = 27